import { useTranslationsContext } from 'contexts/translationsContext';

import { IconArrowLeft } from '@tabler/icons-react';

import { FXSGoTo } from './styles';

const GoToFXS = () => {
	const { t } = useTranslationsContext();

	return (
		<FXSGoTo
			href={window.config.Variables.FxsSite}
			data-ga4event-clk-name='header_click'
			data-ga4event-element='back_to_fxstreet'
		>
			<IconArrowLeft stroke={2} width={16} />
			<span>{t('goto')}</span>
		</FXSGoTo>
	);
};

export default GoToFXS;
